import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0% 0%;
  z-index:0;
  border-bottom: 1px solid #eee;
  max-width: 1280px;
  margin: auto;
  font-size:18px;
  @media (max-width: 876px) {
    padding: 5%;
  }
`;

export default Wrapper;
